import { apiSlice } from "../../app/api/apiSlice";

export const customerPersonasApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerPersonas: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/customer_personas/",
        params: {
          ...params,
          include_deactivated: params?.include_deactivated || "true",
        },
      }),
      providesTags: ["CustomerPersona"],
    }),
    getCustomerPersonasInfiniteScroll: builder.query({
      query: (pageNumber) =>
        `/api/v1/resources/customer_personas?page=${pageNumber}&page_size=36&scope=shared_and_user`,
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge: (currentCache, newItems) => {
        // Check if currentCache has a 'results' property and create a new array with the combined data
        if (
          currentCache &&
          currentCache.results &&
          Array.isArray(currentCache.results)
        ) {
          return {
            ...newItems,
            results: [...currentCache.results, ...newItems.results],
          };
        }
        // If currentCache is not in the expected format, return newItems
        return newItems;
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg;
      },
      // providesTags: ["CustomerPersona"],
    }),
    fetchCustomerPersonaById: builder.query({
      query: (id) => `/api/v1/resources/customer_personas/${id}/`,
      providesTags: (result, error, id) => [{ type: "CustomerPersona", id }],
    }),
    createCustomerPersona: builder.mutation({
      query: (purpose_of_visit) => ({
        url: "/api/v1/resources/customer_personas/",
        method: "POST",
        body: { purpose_of_visit },
      }),
      invalidatesTags: ["CustomerPersona"],
    }),
    deleteCustomerPersona: builder.mutation({
      query: (id) => ({
        url: `/api/v1/resources/customer_personas/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["CustomerPersona"],
    }),
    updateCustomerPersona: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/api/v1/resources/customer_personas/${id}/`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: ["CustomerPersona"],
    }),
  }),
});

export const {
  useGetCustomerPersonasQuery,
  useGetCustomerPersonasInfiniteScrollQuery,
  useFetchCustomerPersonaByIdQuery,
  useCreateCustomerPersonaMutation,
  useDeleteCustomerPersonaMutation,
  useUpdateCustomerPersonaMutation,
} = customerPersonasApiSlice;
